import { FilterOperation } from './dataProvider';

export const ColumnType = {
  TEXT: 'ColumnType.TEXT',
  CHECK: 'ColumnType.CHECK',
  ENUM: 'ColumnType.ENUM',
  NUMBER: 'ColumnType.NUMBER',
  DATETIME: 'ColumnType.DATETIME',
  DATETIMEWITHOUTZONE: 'ColumnType.DATETIMEWITHOUTZONE',
  DATE: 'ColumnType.DATE',
  TIME: 'ColumnType.TIME',
  JSX: 'ColumnType.JSX',
  YESNO: 'ColumnType.YESNO'
};

export const DataActions = {
  INIT: 'DataActions.INIT',
  SET_ITEMS: 'DataActions.SET_ITEMS',
  LOAD: 'DataActions.LOAD',
  FILTER_REMOVE: 'DataActions.FILTER_REMOVE',
  FILTER_RESET_VALUE: 'DataActions.FILTER_RESET_VALUE',
  FILTER_RESET_VALUES: 'DataActions.FILTER_RESET_VALUES',
  FILTER_ADD: 'DataActions.FILTER_ADD',
  FILTER_EDIT: 'DataActions.FILTER_EDIT',
  FILTER_DEFAULT: 'DataActions.FILTER_DEFAULT',
  PAGE_SIZE: 'DataActions.PAGE_SIZE',
  PAGE: 'DataActions.PAGE',
  SORT: 'DataActions.SORT',
  ORDER: 'DataActions.ORDER',
  FILTER_OPEN: 'DataActions.FILTER_OPEN',
};

export const filterTranslations = {
  [FilterOperation.EQ]: 'rovná se',
  [FilterOperation.NEQ]: 'nerovná se',
  [FilterOperation.GT]: 'je větší',
  [FilterOperation.LT]: 'je menší',
  [FilterOperation.GTE]: 'je větší nebo rovno',
  [FilterOperation.LTE]: 'je menší nebo rovno',

  [FilterOperation.STARTWITH]: 'začíná s',
  [FilterOperation.ENDWITH]: 'končí s',
  [FilterOperation.CONTAINS]: 'obsahuje',
};

export const filterOperations = {
  [ColumnType.NUMBER]: [
    FilterOperation.EQ,
    FilterOperation.NEQ,
    FilterOperation.GT,
    FilterOperation.LT,
    FilterOperation.GTE,
    FilterOperation.LTE,
  ],
  [ColumnType.TEXT]: [
    FilterOperation.EQ,
    FilterOperation.NEQ,
    FilterOperation.STARTWITH,
    FilterOperation.ENDWITH,
    FilterOperation.CONTAINS,
  ],
  [ColumnType.DATE]: [
    FilterOperation.EQ,
    FilterOperation.NEQ,
    FilterOperation.GT,
    FilterOperation.LT,
    FilterOperation.GTE,
    FilterOperation.LTE,
  ],
  [ColumnType.DATETIMEWITHOUTZONE]: [
    FilterOperation.EQ,
    FilterOperation.NEQ,
    FilterOperation.GT,
    FilterOperation.LT,
    FilterOperation.GTE,
    FilterOperation.LTE,
  ],
  [ColumnType.DATETIME]: [
    FilterOperation.EQ,
    FilterOperation.NEQ,
    FilterOperation.GT,
    FilterOperation.LT,
    FilterOperation.GTE,
    FilterOperation.LTE,
  ],
  [ColumnType.YESNO]: [FilterOperation.EQ],
  [ColumnType.JSX]: [],
  [ColumnType.CHECK]: [FilterOperation.EQ],
  [ColumnType.ENUM]: [
    FilterOperation.CONTAINS,
    FilterOperation.EQ,
  ],
};
